<template>
  <div class="product-form-field-switch flex justify-between">
    <div class="w-3/4">
      <label class="text-base font-bold mb-4 block " :for="$attrs.id">
        <slot name="label" />
      </label>
      <div class="help">
        <slot name="help" />
      </div>
    </div>
    <div class="pxl-5 relative">
      <input
        v-model="computedValue"
        class="input"
        type="checkbox"
        :disabled="disabled"
        :name="name"
        :required="required"
        :value="nativeValue"
        :true-value="trueValue"
        :false-value="falseValue"
        @click.stop
      >
    </div>
  </div>
</template>

<script>
// @TODO - Borrowed from Hope to be able to clean a lot of this out to still be a transparent component.
// based off: https://github.com/buefy/buefy/blob/dev/src/components/checkbox/Checkbox.vue
export default {
  name: 'AppSwitch',
  props: {
    value: {
      type: [String, Number, Boolean, Function, Object, Array, Symbol],
      default: Boolean,
    },
    nativeValue: {
      type: [String, Number, Boolean, Function, Object, Array, Symbol],
      default: Boolean,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: '',
    },
    trueValue: {
      type: [String, Number, Boolean, Function, Object, Array, Symbol],
      default: true,
    },
    falseValue: {
      type: [String, Number, Boolean, Function, Object, Array, Symbol],
      default: false,
    },
  },
  data () {
    return {
      newValue: this.value,
      isMouseDown: false,
    }
  },
  computed: {
    computedValue: {
      get () {
        return this.newValue
      },
      set (value) {
        this.newValue = value
        this.$emit('input', value)
      },
    },
  },
  watch: {
    /**
     * When v-model change, set internal value.
     */
    value (value) {
      this.newValue = value
    },
  },
}
</script>

<style scoped>
.input {
  width: 64px;
  height: 36px;
  cursor: pointer;
  transition: all 0.5s;

  @apply rounded-full;
  @apply bg-grey-400;
  @apply border border-grey-500 border-2 opacity-100;
}

input:checked {
  @apply bg-green-500 !important;
  @apply border-green-500;
}

input:focus {
  @apply shadow-outline;
}

input::before {
  position: relative;
  z-index: 10;
  width: 50%;
  height: 32px;
  content: '';
  transition: all 0.5s;

  @apply rounded-full border-0 bg-white shadow block;
}

input:checked::before {
  content: '';
  transform: translateX(100%);
}

/* input::after {
  content: 'NO';
  position: absolute;
  z-index: 0;
  top: 0;
  left: 40px;
  padding: 0.4rem 0.5rem;
  @apply text-grey-700;
  transition: color 0.5s;
}
input:checked::after {
  content: 'YES';
  left: 0;
  @apply text-white;
} */
</style>
